import { FC, ReactNode } from 'react'
import { Button as UiButton } from '@cargomart/ui'
import ModalItem from 'components/ModalItem'
import { ModalSimple } from 'components/ModalSimple'

export interface OrderFilterFilterModalProps {
  children: ReactNode
  id: string
  onClose: () => void
  orderCountText: string
}

export const OrderFilterFilterModal: FC<OrderFilterFilterModalProps> = ({ id, orderCountText, onClose, children }) => (
  <ModalItem id={id}>
    <ModalSimple
      id={id}
      onClose={onClose}
      title="Параметры заявки"
      mobileModalFooter={
        <UiButton className="block w-full" onClick={onClose} size="lg" variant="solid">
          {orderCountText}
        </UiButton>
      }
      modalFooter={
        <div className="ml-auto flex gap-x-2">
          <UiButton onClick={onClose} size="lg" variant="solid">
            {orderCountText}
          </UiButton>
        </div>
      }
    >
      {children}
    </ModalSimple>
  </ModalItem>
)
